import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";

import type { OrganizationDateFormats } from "@waterly/utils-isomorphic";
import { getOrganizationDateFormats } from "@waterly/utils-isomorphic";

// defaults to the american family so pickers work without a provider, the app provides the org's formats once
const DateFormatsContext = createContext<OrganizationDateFormats>(getOrganizationDateFormats());

export type DateFormatsProviderProps = {
  dateFormats: OrganizationDateFormats;
};

export const DateFormatsProvider = ({
  dateFormats,
  children,
}: PropsWithChildren<DateFormatsProviderProps>) => (
  <DateFormatsContext.Provider value={dateFormats}>{children}</DateFormatsContext.Provider>
);

export const useDateFormats = () => useContext(DateFormatsContext);
